import styled, { css } from 'styled-components'
import { Field, ErrorMessage } from 'formik'
import media from 'css-in-js-media'
import { Variables } from '../styles/Variables'
import React from 'react';
import { CheckboxContainer } from './Checkbox';


export const ValidationError = styled(ErrorMessage)`
    font-size: 12px;
    line-height: 120%;
    letter-spacing: 0.0025em;
    margin: 0;
    color: #d55961;
    padding-left: 20px;
    position: absolute;
    bottom: 14px;
    right: 10px;

    :before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        width: 12px;
        height: 12px;
        background-image: url('/svg/warning-circle.svg');
        background-repeat: no-repeat;
        background-position: center center;
        border-radius: 12px;
        background-size: 12px;
        transform: translate(0, -50%);
    }
`


export const InputStyle = css`
    font-family: ${Variables.font.body};
    font-weight: normal;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.005em;
    padding: 18px 10px  14px 0px;
    height: 50px;
    border: none ;
    border-bottom: 1px solid ${Variables.color.white};    
    border-radius: 0;
    outline: none;
    background: none;
    box-sizing: border-box;
    -webkit-appearance: none;

    ${media('>=desktop')} {              
        box-sizing: border-box;        
        font-size: 20px;
        line-height: 18px;
        color: ${Variables.color.white};
        height: 50px;
    }

    ::placeholder {
        color: white;
    }

    :-webkit-autofill {
        -webkit-box-shadow: 0 0 0 50px transparent inset;
        -webkit-text-fill-color: ${Variables.color.white};
    }

    :focus {
        border-color: white;
    }
`

export const Input = styled(Field)`
    color: ${Variables.color.lightGrey};
    ${InputStyle}
`

export const Textarea = styled(Field)`
    ${InputStyle}
    background-color: ${Variables.color.white} ;
    color: ${Variables.color.cocoa} !important;
    min-height: 83px;
    margin-top: 36px;
    min-height: 169px;
    padding-left:  21px;

    ${media('<desktop')} {
        margin-top: 10px;
    }

    ::placeholder {
        color: ${Variables.color.cocoa} !important;
    }

    :focus {
        border-color: ${Variables.color.cocoa};
    }
`

export const StyledSelect = styled(Field)`
    ${InputStyle}
    color: #ffffff;
    /* background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.25 1.5L7 7.75L0.75 1.5' stroke='white' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A"); */
    background-position: 96% 22px;
    background-repeat: no-repeat;
    cursor: pointer;

    ${media('>=desktop')} {
        background-position: 98% 20px;
    }

    option {
        color: #000000;
    }

    :disabled {
        opacity: 1;
    }

    + ${ValidationError} {
        right: 33px;
    }
`

export const Select = ({ children, ...props }) => {
    return <StyledSelect {...props}>{children}</StyledSelect>
}

export const InputRow = styled.div`
    width: 100%;
    display: flex;
    margin: 0 0 15px 0;
    box-sizing: border-box;
    flex-wrap: wrap;
    position: relative;

    ${media('>=desktop')} {
        margin: 0 0 20px;
    }

    ${StyledSelect}, ${Input}, ${Textarea} {
        width: 100%;
    }

    ${Textarea} {
        ${media('<desktop')} {
            min-height: 140px;
        }
    }

    ${CheckboxContainer} {
        ${media('<desktop')} {
            margin-top: 10px;
        }
    }

    &:first-child {
        ${media('>=desktop')} {
            margin-top: 0;
        }
    }

    // Group field
    ${(props) =>
        props.group &&
        css`
            border-radius: 0;
            flex-wrap: nowrap;            
        `}

    // Validation error
    ${(props) =>
        props.error &&
        css`
            border-color: ${Variables.color.red};
            ${StyledSelect}, ${Input}, ${Textarea} {
                border-color: ${Variables.color.red};
            }
        `}
`
